app
    .controller('CoachLiveWorkoutFormCtrl', function CoachImageFormCtrl($http) {
        this.bundleHours = [];
        const hourEnd = 8;
        for (let i = 0; i <= 8; i++) {
            if (i > 0) {
                this.bundleHours.push({
                    value: i,
                });
            }
            if (i !== hourEnd) {
                this.bundleHours.push({
                    value: i + 0.25
                });
                this.bundleHours.push({
                    value: i + 0.5
                });
                this.bundleHours.push({
                    value: i + 0.75
                });
            }
        }

        this.cancel = () => {
            this.dismiss();
        };

        this.save = () => {
            const service = this.services[0];
            let promise;
            if(service.id){
                promise = $http.post(`/coach/service/${service.id}`, service);
            } else {
                promise = $http.post(`/coach/service`, service);
            }

            promise.then(() => {
               this.close();
            });
        };

        this.$onInit = () => {
            this.services = this.resolve.coach.liveWorkouts;
            if (!this.services || this.services.length === 0){
                this.services = [{currency: 'USD', price: 0, bundledHours: 1, serviceType: 'live'}];
            }
        };
    })
    .component('coachLiveWorkoutForm', {
        template: `
        <form ng-submit="$ctrl.save()">
        <div class="modal-header">
            <h3 class="modal-title" id="modal-title">
                <chat-icon type="program" width="18"/>
                {{ 'modal.liveWorkout.title' | translate}}
            </h3>
            <button class="btn btn-close" ng-click="$ctrl.cancel()">
                <chat-icon type="cross" width="15" />
            </button>
        </div>
        <div class="modal-body" id="modal-body" ng-repeat="service in $ctrl.services">
            <div class="form-group">
                <label for="">{{ 'modal.liveWorkout.label.bundleTitle'  | translate}}</label>
                <input type="text" class="form-control" ng-model="service.title" />
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="">{{ 'modal.liveWorkout.label.bundleHour' | translate }}</label>
                    <select class="form-control custom-select" ng-model="service.bundledHours">
                        <option ng-value="hour.value" ng-repeat="hour in $ctrl.bundleHours">{{hour.value | timed}}</option>
                    </select>
                </div>
                <div class="form-group col-md-8">
                  <label for="inputPassword4">{{'modal.liveWorkout.label.bundlePrice'  | translate}}</label>
                  <input type="text" class="form-control" readonly value="{{ service.bundledHours * service.price }} {{service.currency}}" />
                </div>
              </div>

            <div class="form-row">
                <div class="form-group col-md-8">
                    <label for="">{{ 'modal.liveWorkout.label.priceProgram' | translate}}</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                      </div>
                      <input type="number" class="form-control" ng-model="service.price">
                    </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="inputPassword4">{{ 'modal.liveWorkout.label.currency' | translate}}</label>
                  <select type="password" class="form-control custom-select" ng-model="service.currency">
                    <option value="USD" selected> USD </option>
                    <option value="CAD"> CAD </option>
                  </select>
                </div>
              </div>

            <div class="form-group">
                <label for="">{{ 'modal.liveWorkout.label.description' | translate}}</label>
                <textarea type="text" class="form-control" ng-model="service.description"></textarea>
                <span class="form-text text-muted"><small>{{ 'modal.liveWorkout.helpText.description' | translate}}</small></span>
            </div>
            <div style="display: flex; justify-content: space-between">
                <div style="display: flex; align-items: center">
                    <span class="mr-3">{{ 'modal.liveWorkout.label.visible' | translate}}</span>
                    <toggle-switch ng-model="service.visible"/>
                </div>
                <div>
                    <button type="button" class="btn"> <chat-icon type="cross" width="15" /> &nbsp;{{ 'modal.liveWorkout.button.erase' | translate}} </button>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-save" type="submit">{{ 'modal.liveWorkout.button.save' | translate}}</button>
        </div>
        </form>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'CoachLiveWorkoutFormCtrl'
    });
